import React from 'react';
const ErrorScreen = () => {
  return <div className="flex flex-col justify-center items-center min-h-screen text-center px-4" data-sentry-component="ErrorScreen" data-sentry-source-file="ErrorBoundary.tsx">
      <h2 className="text-neutral-70 font-semibold text-lg">
        Oops, Something went wrong!
      </h2>
    </div>;
};
export default ErrorScreen;